import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IconRegistryService {
  private http = inject(HttpClient);
  private cache = new Map<string, Observable<string>>();

  getIcon$(name: string): Observable<string> {
    const key = name.trim();
    const cached = this.cache.get(key);
    if (cached) return cached;

    const req$ = this.http
      .get(`assets/icons/${key}.svg`, { responseType: 'text' as const })
      .pipe(shareReplay(1));

    this.cache.set(key, req$);
    return req$;
  }
}